<template>
  <div>
    <div>
      <v-layout row wrap>
        <v-flex xs12 sm2 pt-2 hidden-xs-only>
          <div class="fixed-celebration-buttons">
            <v-btn
              depressed
              v-for="benefit_type in benefits.benefit_types"
              :key="benefit_type.name"
              :color="benefitTypeNameClass(benefit_type.name) == selectedCategory ? '#28385C' : 'white'"
              block
              :class="benefitTypeNameClass(benefit_type.name) == selectedCategory ? 'white--text font-weight-bold' : ''"
              @click="goTo(benefitTypeNameClass(benefit_type.name))"
            >
              {{ benefit_type.name }}
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12 hidden-sm-and-up mt-4 class="select-category px-2">
          <v-select
            :items="benefitItems"
            v-model="benefitTypeSelected"
            label="Categoría"
            solo
            outline
            @change="goTo(benefitTypeNameClass(benefitTypeSelected))"
          ></v-select>
        </v-flex>
        <v-flex :class="{'xs12 sm9 pl-4 mt-3': $vuetify.breakpoint.smAndUp, 'xs12 sm12': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap v-for="(benefit_type, i) in benefits.benefit_types" :key="i">
            <v-flex
              :class="[benefitTypeNameClass(benefit_type.name), classTextBenefitType, $vuetify.breakpoint.smAndDown ? 'pl-2' : 'pl-3']"
              xs12 sm12
            >
              {{ benefit_type.name }}
            </v-flex>

            <BenefitItem
              v-for="(benefit, i) in benefit_type.benefits"
              :key="i"
              :benefit="benefit"
              xs12
            />
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BenefitItem from "@/components/Benefits/BenefitItem";

export default {
  props: {
    benefits: {
      required: true
    }
  },
  components: {
    BenefitItem
  },
  data() {
    return {
      selectedCategory: '',
      benefitTypeSelected: '',
      benefitsWatcher: null,
    };
  },
  computed: {
    benefitItems() {
      let items = [];
      if (this.benefits && this.benefits.benefit_types) {
        this.benefits.benefit_types.forEach(element => {
          items.push(element.name);
        });
      }
      return items;
    },
    classTextBenefitType() {
      return this.$vuetify.breakpoint.smAndDown
        ? "text-17-security blue-security font-weight-bold pb-2"
        : "text-25-security blue-security font-weight-bold pb-4";
    }
  },
  watch: {
    '$route.query.category': {
      handler(newCategory, oldCategory) {
        if (newCategory && newCategory !== oldCategory) {
          const normalizedCategory = this.normalizeCategoryName(newCategory);
          this.selectedCategory = normalizedCategory;

          if (this.benefits && this.benefits.benefit_types && this.benefits.benefit_types.length > 0) {
            this.$nextTick(() => {
              this.scrollToCategory(normalizedCategory);
            });
          } else {
            if (!this.benefitsWatcher) {
              this.benefitsWatcher = this.$watch(
                () => this.benefits.benefit_types,
                (newVal) => {
                  if (newVal && newVal.length > 0) {
                    this.$nextTick(() => {
                      this.scrollToCategory(normalizedCategory);
                    });
                    if (this.benefitsWatcher) {
                      this.benefitsWatcher();
                      this.benefitsWatcher = null;
                    }
                  }
                }
              );
            }
          }
        }
      },
      immediate: true,
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    const category = this.$route.query.category;
    if (category) {
      const normalizedCategory = this.normalizeCategoryName(category);
      this.selectedCategory = normalizedCategory;

      if (this.benefits && this.benefits.benefit_types && this.benefits.benefit_types.length > 0) {
        this.$nextTick(() => {
          this.scrollToCategory(normalizedCategory);
        });
      } else {
        if (!this.benefitsWatcher) {
          this.benefitsWatcher = this.$watch(
            () => this.benefits.benefit_types,
            (newVal) => {
              if (newVal && newVal.length > 0) {
                this.$nextTick(() => {
                  this.scrollToCategory(normalizedCategory);
                });
                if (this.benefitsWatcher) {
                  this.benefitsWatcher();
                  this.benefitsWatcher = null;
                }
              }
            }
          );
        }
      }
    }
  },
  beforeDestroy() {
    if (this.benefitsWatcher) {
      this.benefitsWatcher();
      this.benefitsWatcher = null;
    }
  },
  methods: {
    ...mapActions("benefits", ["fetchBenefits"]),
    benefitTypeNameClass(name) {
      return name.replace(/\s/g, '_').toLowerCase();
    },
    normalizeCategoryName(name) {
      return name.replace(/-/g, '_').toLowerCase();
    },
    goTo(element_id) {
      this.selectedCategory = element_id.toLowerCase();
      this.scrollToCategory(element_id);
      const categoryParam = element_id.replace(/_/g, '-');
      if (this.$route.query.category !== categoryParam) {
        this.$router.push({ path: '/beneficios', query: { category: categoryParam } });
      }
    },
    scrollToCategory(element_id) {
      const normalizedElementId = element_id.replace(/-/g, '_');
      const element = document.getElementsByClassName(normalizedElementId)[0];
      if (element) {
        const navbarHeight = document.querySelector('.ttf-menu')?.offsetHeight || 236;

        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - navbarHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } else {
        console.log(`Elemento no encontrado: ${normalizedElementId}`);
      }
    }
  }
};
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 0.7;
    position: absolute;
    width: 100%;
  }

  .btn-selected {
    background: #28385C !important;
    border-color: #28385C !important;
    color: white;
    font-weight: 700;
    font-size: 14px;
    border-radius: 8px;
    padding: 0px 46.5px;
    height: 30px;
  }
</style>
